const layout = {
  slug: 'f/layout',
  getHeaderMenuList: slug => `${layout.slug}/header`,
  getFooterMenuList: () => `${layout.slug}/footer`,
  getStayConnected: () => `${layout.slug}/channels`
}

export default layout
